import angular from 'angular';
import _ from 'lodash';
import deleteModalTemplate from './catalog.delete.modal.html';
import removeModalTemplate from './catalog.remove.modal.html';

class MenuCatalogController {
  /* @ngInject */
  constructor($rootScope, $log, $timeout, $translate, ModalFactory, PaginationSettings, ProductsActions, ProductsStore, MenuStore, StoreStates, StorageService, MenuActions) {
    const that = this;

    that.loading = {
      products: false
    };

    let products = [];

    let allProducts = [];

    that.pagination = {
      currentPage: {
        number: 0,
        data: []
      }
    };

    that.filters = {
      search: {
        terms: [],
        text: ''
      }
    };

    this.onStoreSelected = () => {
      MenuStore.forceExpired();
      ProductsStore.forceExpired();
      loadProducts(0, PaginationSettings.DEFAULT_PAGE_SIZE);
    }


    const loadProducts = (start, end) => {
      if(!start && !end) {start = 0; end = PaginationSettings.DEFAULT_PAGE_SIZE}
      
      if(MenuStore.getMenuStoreState() === StoreStates.STORE_VALID){
        products = ProductsStore.getProducts();
      }

      if (that.productIds !== undefined) {
        products = that.menu.products
        var productsList = products.list ? products.list : products;
        that.pagination.elementsCount = products.pagination ? products.pagination.totalElements : products.length;
        that.pagination.currentPage.data = productsList;
        that.loading.products = false;
      } else {
        if (ProductsStore.getProductsStoreState() === StoreStates.STORE_VALID ) {
          products = ProductsStore.getProducts();
          var productsList = products.list ? products.list : products;

          that.pagination.elementsCount = products.pagination ? products.pagination.totalElements : products.length;
          that.pagination.currentPage.data = productsList;
          that.loading.products = false;

        } else if (ProductsStore.getProductsStoreState() !== StoreStates.STORE_PENDING_UPDATE || ProductsStore.getProductsStoreState() === StoreStates.STORE_EXPIRED) {
          that.loading.products = true;
          ProductsActions.getProducts(start, end);
        }
      }
    };

    const loadAllProduct = () => {
      if (ProductsStore.getAllProductsStoreState() === StoreStates.STORE_VALID && that.chooseProducts){
        that.allProducts = ProductsStore.getAllProducts().list;
        
        if (that.isSelect) {
           that.allProducts = _.map(that.allProducts, product => {
            const parsedProduct = product;
            if (that.allProducts.length > 0) {
              parsedProduct.selected = that.selectedProducts.findIndex(selectedProduct => selectedProduct.id == parsedProduct.id) > -1;
            } else {
              parsedProduct.selected = false;
            }
            return parsedProduct;
          });
          if (that.allProducts.length === that.selectedProducts.length) {
            that.allProducts.allproducts = true;
          } else {
            that.allProducts.allproducts = false;
          }
        }

        that.pagination.elementsCount = that.allProducts.pagination ? that.allProducts.pagination.totalElements : that.allProducts.length;
        that.pagination.currentPage.data = that.allProducts;
        that.loading.products = false;
      }
    }

    const loadProductsForSearch = (fromInit = false) => {
      if (ProductsStore.getAllProductsStoreState() === StoreStates.STORE_VALID && !fromInit){
          if (that.filters.search.terms.length > 0) {
            products = ProductsStore.searchProducts(that.filters.search.terms);
          }else{
            products = ProductsStore.getProducts();
          }
          that.pagination.elementsCount = products.pagination ? products.pagination.totalElements : products.length;
          that.pagination.currentPage.data = products;
          that.loading.products = false;
      }else{
        ProductsActions.getAllProducts();
      }
    }

    const init = () => {
      that.isCondensed = that.condensed !== undefined;
      if (that.select !== undefined) {
        that.isSelect = true;
        if (!angular.isArray(that.selectedProducts)) {
          that.selectedProducts = [];
        }
      } else {
        that.isSelect = false;
      }

      if(that.chooseProducts){
        that.loading.products = true;
        ProductsActions.getAllProducts();
      }else{
        loadProducts(0, PaginationSettings.DEFAULT_PAGE_SIZE);
        loadProductsForSearch(true)
      }
    };

    const closeModal = modal => {
      modal.deactivate();
      $timeout(modal.destroy, 1000);
    };

    that.$onInit = init;

    that.changePage = (page = 0) => {
      if (products.list === undefined) return;
      that.pagination.currentPage.number = page;
      if (that.isCondensed || that.isSelect) {
        that.pagination.currentPage.data = products.list;
      } else {
        PaginationSettings.DEFAULT_PAGE_SIZE;
        ProductsActions.getProducts(page, PaginationSettings.DEFAULT_PAGE_SIZE);
      }
    };

    that.deleteProduct = product => {
      if (ProductsStore.getProductsStoreState() === StoreStates.STORE_PENDING_UPDATE) return;

      const modal = new ModalFactory({
        ovarlay: true,
        overlayClose: false,
        template: deleteModalTemplate,
        class: 'medium',
        contentScope: {
          description: $translate.instant('menu.catalog.products.delete.body.description', {
            name: product.name,
            description: product.description
          }),
          cancel: () => closeModal(modal),
          delete: () => {
            that.loading.products = true;
            var merchantProfile = JSON.parse(StorageService.getLocalStorage('userContext'));
            ProductsActions.deleteProduct(product.id, merchantProfile.business.id);
            closeModal(modal);
          }
        }
      });

      modal.activate();
    };

    that.createProduct = () => {
      const modal = new ModalFactory({
        overlay: true,
        overlayClose: false,
        template: '<edit-product mode="create" on-cancel="cancel()"></edit-product>',
        class: 'large',
        contentScope: {
          cancel: () => closeModal(modal)
        }
      });

      modal.activate();
    };

    that.editProduct = product => {
      const modal = new ModalFactory({
        overlay: true,
        overlayClose: false,
        template: '<edit-product mode="edit" on-cancel="cancel()" product="product"></edit-product>',
        class: 'large',
        contentScope: {
          cancel: () => closeModal(modal),
          product: angular.copy(product)
        }
      });

      modal.activate();
    };

    that.toggleProductAvailability = product => {
      if (ProductsStore.getProductsStoreState() === StoreStates.STORE_PENDING_UPDATE) return;
      if (product.available) {
        ProductsActions.hideProduct(product.id);
      } else {
        ProductsActions.showProduct(product.id);
      }

      product.available = !product.available; // eslint-disable-line

      let deregProductAvailabilityListener = undefined;
      let deregProductAvailabilityFailListener = undefined;

      deregProductAvailabilityListener = $rootScope.$on(`SAVEPRODUCT_AVAILABILITY_${product.id}`, () => {
        deregProductAvailabilityListener();
        deregProductAvailabilityFailListener();
      });

      deregProductAvailabilityFailListener = $rootScope.$on(`SAVEPRODUCT_AVAILABILITY_FAIL_${product.id}`, () => {
        product.available = !product.available; // eslint-disable-line
        deregProductAvailabilityListener();
        deregProductAvailabilityFailListener();
      });
    };

    that.toggleSelectAll = () => {
      if (!that.isSelect) return;

      if (that.selectedProducts.length === that.allProducts.length) {
        that.selectedProducts.splice(0, that.selectedProducts.length);
        _.forEach(that.allProducts, product => {
          product.selected = false; // eslint-disable-line
        });
      } else {
        that.selectedProducts.splice(0, that.selectedProducts.length);
        _.forEach(that.allProducts, product => {
          product.selected = true; // eslint-disable-line
          that.selectedProducts.push(product);
        });
      }
    };

    /*that.toggleSelectAll = () => {
      if (!that.isSelect) return;

      if (that.selectedProducts.length === products.length) {
        that.selectedProducts.splice(0, that.selectedProducts.length);
        _.forEach(products, product => {
          product.selected = false; // eslint-disable-line
        });
      } else {
        that.selectedProducts.splice(0, that.selectedProducts.length);
        _.forEach(products, product => {
          product.selected = true; // eslint-disable-line
          that.selectedProducts.push(product.id);
        });
      }
    };*/

    that.selectProduct = product => {
      if (product.selected) {
        if (that.selectedProducts.findIndex(selectedProduct => selectedProduct.id == product.id) === -1) {
          that.selectedProducts.push(product);
        }
      } else {
        const productIndex = that.selectedProducts.findIndex(selectedProduct => selectedProduct.id == product.id);
        if (productIndex > -1) {
          that.selectedProducts.splice(productIndex, 1);
        }
      }
    };

    that.removeProductFromMenu = product => {
      if (that.menu === undefined) return;

      const modal = new ModalFactory({
        overlay: true,
        overlayClose: false,
        template: removeModalTemplate,
        contentScope: {
          description: $translate.instant('menu.catalog.products.remove.body.description', {
            name: product.name
          }),
          cancel: () => closeModal(modal),
          remove: () => {
            that.loading.products = true;
            const productIndex = that.menu.products.findIndex(selectedProduct => selectedProduct.id == product.id);
            if (productIndex > -1) {
              that.menu.products.splice(productIndex, 1);
            }
            MenuActions.removeProductFromMenu(that.menu.id, product.id);
            closeModal(modal);
          }
        }
      });
      modal.activate();
    };

    that.onSearch = () => {
      that.loading.products = true;
      $timeout(loadProductsForSearch, 100);
    };

    const deregProductsUpdateListener = $rootScope.$on('PRODUCTS_UPDATE', function (){
      loadProducts(0, PaginationSettings.DEFAULT_PAGE_SIZE)
    });
    const deregAllProductsLoadListener = $rootScope.$on('ALL_PRODUCTS_LOAD', loadAllProduct);
    const deregProductsFailListener = $rootScope.$on('PRODUCTS_FAIL', () => {
      that.loading.products = false;
    });

    const deregSaveMenuListener = $rootScope.$on('SAVEMENU', () => {
      that.loading.products = false;
    });

    const deregSaveMenuFailListener = $rootScope.$on('SAVEMENU_FAIL', () => {
      that.loading.products = false;
    });

    that.$onDestroy = () => {
      deregProductsUpdateListener();
      deregProductsFailListener();
      deregSaveMenuListener();
      deregSaveMenuFailListener();
    };
  }
}

export default MenuCatalogController;



/** WEBPACK FOOTER **
 ** ./client/app/components/menu/catalog/catalog.controller.js
 **/